<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;display: flex;flex-direction: column;">
        <div class="search-container">
            <div class="left-part" :class="{ 'collapsed': !searchShow }">
                <el-input placeholder="批次名称" v-model="userSearch.batch_name" clearable size="small"/>
                <el-select v-model="userSearch.tag" clearable size="small" placeholder="类型" style="width: 120px;">
                    <el-option v-for="(item,index) in tagArr" :key="index" :label="item.name" :value="item.code"></el-option>
                </el-select>
                <el-cascader v-model="userSearch.level_id" @visible-change="getlevelTree" :options="levelTree" :props="{value:'id',label:'name'}" size="small" clearable placeholder="层次" style="width: 120px;"></el-cascader>
                <el-input placeholder="用户姓名" v-model="userSearch.name" clearable size="small" />
                <el-input placeholder="用户手机" v-model="userSearch.phone" clearable size="small"/>
                <el-cascader v-model="userSearch.depart" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true,multiple: true}"  size="small" @visible-change="getDepartmentLists" placeholder="所属部门 "></el-cascader>
                <!-- <el-input placeholder="所属员工账号" clearable v-model="userSearch.admin_phone" size="small"/> -->
                <el-select v-model="userSearch.admin_id" clearable filterable size="small" placeholder="所属员工" @visible-change="selectAdmin">
                    <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
                </el-select>
                <el-select v-model="userSearch.admin_state" clearable size="small" placeholder="员工状态" style="width: 150px;margin-left: 10px;">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="2"></el-option>
                </el-select>
                <el-date-picker v-model="userSearch.created_time" clearable type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="创建开始时间" end-placeholder="创建结束时间" size="small" placeholder="创建时间范围" style="width: 250px;"/>
                <el-date-picker v-model="userSearch.follow_time" clearable type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="跟进开始时间" end-placeholder="跟进结束时间" size="small" placeholder="跟进时间范围" style="width: 250px;"/>
                <div>
                    <el-input v-model.number="userSearch.follow_count_min" clearable size="small" placeholder="跟进次数" style="width: 100px;"/>
                    <span class="m_10 lh_30">到</span>
                    <el-input v-model.number="userSearch.follow_count_max" clearable size="small" placeholder="跟进次数" style="width: 100px;"/>
                </div>
                <div>
                    <el-input v-model.number="userSearch.order_count_min" clearable size="small" placeholder="订单数" style="width: 100px;"/>
                    <span class="m_10 lh_30">到</span>
                    <el-input v-model.number="userSearch.order_count_max" clearable size="small" placeholder="订单数" style="width: 100px;"/>
                </div>
                <el-date-picker v-model="userSearch.dispatch_time" clearable type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="分配开始时间" end-placeholder="分配结束时间" size="small" placeholder="分配时间范围" style="width: 250px;"/>
            </div>
            <div class="right-part">
                <a class="_color" @click="searchShow = !searchShow" > {{ searchShow ? '收缩' : '展开' }} </a>
                <el-button size="mini" @click="getUserLists(1)">筛选</el-button>
                <el-button size="mini" type="success" v-permit="'/admin/crm/applyUser'" @click="openApply">申请线索</el-button>
                <el-button size="mini" type="primary" v-permit="'/admin/crm/userAdd'" @click="openAdd">新增</el-button>
                <el-button size="mini" type="warning" v-permit="'/admin/crm/userExport'" @click="exportVisible=true">导出</el-button>
            </div>
        </div>
		<el-tabs v-model="userSearch.follow_state" type="card" @tab-click="getUserLists(1)">
			<el-tab-pane label="全部" name="0"></el-tab-pane>
			<el-tab-pane v-for="(item,index) in follow_state_arr" :key="index" :label="item.name" :name="item.code + ''"></el-tab-pane>
        </el-tabs>
        <div style="flex: 1;">
            <el-table :data="list" height="100%" stripe :header-cell-style="{ background:'#f5f5f5'}" ref="multipleTable" v-loading="tableLoading" @selection-change="handleSelectionChange" row-key="id">
                <el-table-column type="selection" :reserve-selection="true"  width="55"></el-table-column>
                <el-table-column prop="id" label="用户编号">
                    <template v-slot="{row}">
                        <p><span class="_color">编号：</span>{{row.id}}</p>
                        <p><span class="_color">名称：</span>{{row.name}}</p>
                        <p><span class="_color">手机：</span>{{row.phone}}</p>
                        <p><span class="_color">备注：</span></p>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="所属部门员工">
                    <template v-slot="{row}">
                        <div style="display: flex;">
                            <div style="margin-right: 10px;">
                                <div v-for="(admin,index) in row.admins" :key="index" style="text-align: right;"> {{admin.depart_name}} : </div>
                            </div>
                            <div>
                                <div v-for="(admin,index) in row.admins" :key="index"> {{admin.nick_name}} {{admin.phone ? admin.phone.slice(-4) : ''}} </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="导入批次">
                    <template v-slot="{row}">
                        <p><span class="_color">批次：</span>{{row.batch ? row.batch.id : ''}}</p>
                        <p><span class="_color">名称：</span>{{row.batch ? row.batch.name : ''}}</p>
                        <p><span class="_color">操作：</span><span v-if="row.batch && row.batch.admin && row.batch.admin.admin_id">{{row.batch.admin.nick_name}} {{row.batch.admin.phone.slice(-4)}}</span></p>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="标签">
                    <template v-slot="{row}">
                        <p><span class="_color">类型：</span>{{row.tag_text}}</p>
                        <p><span class="_color">来源：</span>{{row.source_text}}</p>
                        <p><span class="_color">状态：</span>{{row.state_text}}</p>
                        <p><span class="_color">跟进状态：</span>{{row.follow_state_text}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="跟进">
                    <template v-slot="{row}">
                        <p><span class="_color">建档：</span>{{row.created_time}}</p>
                        <p><span class="_color">跟进：</span>{{row.follow_count}}</p>
                        <p><span class="_color">最近：</span>{{row.follow_last_time}}</p>
                        <p><span class="_color">人员：</span>{{row.follow_last_admin ? row.follow_last_admin.nick_name : ''}} {{row.follow_last_admin ? row.follow_last_admin.phone : ''}}</p>
                    </template>
                </el-table-column> 
                <el-table-column label="操作" width="110px" align="center">
                    <template v-slot="{row}" style="display: flex;flex-direction: column;">
                        <el-button type="primary" size="mini" v-if="checkAuth('/admin/crm/userDetail')" @click="openDetail(row.id)">详情</el-button>
                        <el-button type="success" size="mini" style="margin-left: 0;margin-top: 10px;" v-if="row.admin_id.includes(loginInfo.admin_id) && checkAuth('/admin/crm/followLog')" @click="openFollow(row)">跟进</el-button>
                        <el-button type="danger" size="mini" plain style="margin-left: 0;margin-top: 10px;" v-if="row.draft_order_id" @click="openDraft(row, row.draft_order_id)">订单草稿</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="指派到部门" :visible="dispatchDepartVisible" width="600px" center destroy-on-close @close="dispatchDepartVisible=false">
            <div class="mb_20">选择记录：<span class="ml_20 red">{{selectedUsers.length}}</span></div>
            <div class="mb_20 _flex _f_ai" style="display: flex;flex-direction: column;align-items: flex-start;">
                <div>选择部门：<span class="c9">(线索资源将指派给选中部门，由负责人二次分配)</span></div>
                <el-cascader v-model="dispatchDepartForm.depart_id" :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" clearable style="width: 300px;margin-left: 70px;margin-top: 10px;"></el-cascader>
            </div>
            <div class="mb_20 _flex _f_ai" style="display: flex;flex-direction: column;align-items: flex-start;">
                <div>标签标识：</div>
                <div style="display: flex;flex-direction: column;align-items: flex-start;margin-left: 70px;">
                    <div class="_flex _f_ai">
                        线索类型
                        <el-select v-model="dispatchDepartForm.tag" clearable class="w_70 ml_10" placeholder="请选择">
                            <el-option v-for="(item,index) in tagArr" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </div>
                    <div class="_flex _f_ai mt_20">
                        跟进状态
                        <el-select v-model="dispatchDepartForm.follow_state" clearable class="w_70 ml_10" placeholder="请选择">
                            <el-option v-for="(item,index) in follow_state_arr" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <el-button type="" @click="dispatchDepartVisible = false">取 消</el-button>
                <el-button type="primary" @click="hanleDispatchDepart">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="分配员工" :visible="dispatchAdminVisible" width="800px" center destroy-on-close @close="dispatchAdminVisible=false">
            <div class="mb_20">选择记录：<span class="ml_20 red">{{selectedUsers.length}}</span></div>
            <div class="mb_20">跟进状态：
                <el-select v-model="dispatch_admin_follow_state" class="w_70 ml_10" clearable placeholder="请选择">
                    <el-option v-for="(item,index) in follow_state_arr" :key="index" :label="item.name" :value="item.code"> </el-option>
                </el-select>
            </div>
            <div class="mb_10 _flex _f_ai" @click="selectAdminVisible=true">
                选择员工：<span class="ml_20 red">{{selectedAdmins.length}}</span>
                <el-button type="success" size="small" plain style="margin-left: 20px;">选择员工</el-button>
            </div>
            <div class="c9">(线索资源平均分配给所选中员工)</div>
            <div style="width: 60%;display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px;margin-top: 10px;">
                <el-tag v-for="admin in selectedAdmins" :key="admin.admin_id" closable 
                    style="font-size: 16px;" @close="rmAdmin(admin.admin_id)"
                >{{admin.nick_name}} {{admin.phone.slice(-4)}}</el-tag>
            </div>
            <!-- <div class="_flex _f_fw c0">
                <div class="bag_d p_5 br_4 m_10" v-for="(item,index) in selectedAdmins" :key="index">
                    {{item.nick_name}} {{item.phone}}
                    <a class="el-icon-circle-close c0 ml_20 f_18" @click="removeAdmin(item)"></a>
                </div>
            </div> -->
            <span slot="footer">
                <el-button type="" @click="dispatchAdminVisible = false">取 消</el-button>
                <el-button type="primary" v-loading="dispatchAdminloading" @click="handleDispatchAdmin">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="选择员工" :visible="selectAdminVisible" width="800px" center destroy-on-close @close="selectAdminVisible=false">
            <AdminSelect v-if="selectAdminVisible" v-model="selectedAdmins" @close="selectAdminVisible=false"></AdminSelect>
        </el-dialog>

        <el-dialog title="业务录单" :visible="orderVisible" width="70%" center @close="orderVisible=false" destroy-on-close>
            <CrmOrder v-if="orderVisible" :user="detail" :order_id="currentOrder ? currentOrder.id : 0" @close="orderVisible = false"></CrmOrder>
        </el-dialog>

        <el-dialog title="跟进记录" :visible="followVisible" width="800px" center destroy-on-close @close="followVisible=false">
              <el-form label-position="right" label-width="100px" :model="formData" class="pr_20">
                <el-form-item label="层级：">
                    <div v-for="(item, index) in levelArr" :key="item.id" v-if="item.pid == 0">
                        <div class="_flex_sb">{{item.name}}</div>
                        <el-radio-group v-model="followForm.level_id" @input="levelChange">
                            <el-radio v-for="(subitem, index) in levelArr" :key="subitem.id" v-if="item.id == subitem.pid" :label="subitem.id">{{subitem.name}}</el-radio>
                        </el-radio-group>
                    </div>
                </el-form-item>
                <el-form-item label="跟进状态：">
                    <div class="c9">(系统跟进状态字段，可扩展)</div>
                    <el-radio-group v-model="followForm.follow_state">
                        <span v-for="(item, index) in levelFollowStateMap" :key="item.code">
                            <br v-if="index % 4 == 0" />
                            <el-radio :label="item.code" style="margin: 0 10px 10px 0;width: 120px;">{{item.name}}</el-radio>
                        </span>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="过程内容：">
                    <el-input v-model="followForm.content" type="textarea" :rows="6" placeholder="请输入内容">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="" @click="followVisible = false">取 消</el-button>
                <el-button type="primary" v-loading="followLoading" @click="handleFollow">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="批量启用禁用" :visible="disableVisible" width="800px" center destroy-on-close @close="disableVisible=false">
            <div class="ml_40">选中记录：<span class="red">{{selectedUsers.length}}</span></div>
            <div class="ml_40 mt_30">
                操<i class="p_10">&nbsp;&nbsp;</i>作：
                <el-radio-group v-model="disableState">
                    <el-radio :label="1">批量启用</el-radio>
                    <el-radio :label="2">批量禁用</el-radio>
                  </el-radio-group>
            </div>
            <span slot="footer">
                <el-button type="" @click="disableVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitDisable">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="预约回访" :visible="todoVisible" width="800px" center destroy-on-close @close="todoVisible=false">
            <el-form label-position="right" label-width="120px" :model="todoForm" class="pr_20">
                <div class="mb_20 ml_20">(预约事项将自动记录到待办事项日历中)</div>
                <el-form-item label="计划事项：">
                    <el-input placeholder="" v-model="todoForm.todo_content"/>
                </el-form-item>
                <el-form-item label="预约时间：">
                    <el-date-picker v-model="todoForm.todo_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"  style="width: 100%;"/>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="" @click="todoVisible = false">取 消</el-button>
                <el-button type="primary" @click="todoHandle">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="订单记录" :visible="orderListVisible" width="80%" center destroy-on-close @close="orderListVisible=false">
            <el-table :data="orderlist" stripe :header-cell-style="{ background:'#f5f5f5'}" row-key="id">
                <el-table-column prop="id" label="订单" min-width="250">
                    <template v-slot="{row}">
                        <div><span class="_color">单号：</span>{{row.order_no}}</div>
                        <div><span class="_color">用户：</span>{{row.user.name}} {{row.user.phone}}</div>
                        <div style="display: flex;align-items: center;">
                            <div class="_color" style="min-width: 46px;">地址：</div>
                            <el-tooltip :content="row.receive_province + row.receive_city + row.receive_area + row.receive_street + row.receive_address" placement="top-start">
                                <span style="max-width:400px;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{row.receive_province}}{{row.receive_city}}{{row.receive_area}}{{row.receive_street}}{{row.receive_address}}</span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="商品" min-width="250">
                    <template v-slot="{row}">
                        <div v-for="(item, gi) in row.goods" :key="item.id">
                            <el-divider v-if="gi"></el-divider>
                            <div style="display: flex;align-items: center;">
                                <div class="_color" style="min-width: 46px;">商品：</div>
                                <el-tooltip :content="item.good_name" placement="top-start">
                                    <span style="max-width:400px;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.good_name}}</span>
                                </el-tooltip>
                            </div>
                            <div><span class="_color">规格：</span>{{item.spec_data_str}}</div>
                            <div><span class="_color">重量：</span>{{item.weight}}</div>
                            <div><span class="_color">单价：</span>{{item.sale_price}} <span class="_color">数量：</span>{{item.quatity}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="金额" min-width="120" max-width="180">
                    <template v-slot="{row}">
                        <div><span class="_color">商品：</span>{{row.good_amount}}</div>
                        <div><span class="_color">加价：</span>{{row.add_amount}}</div>
                        <div><span class="_color">优惠：</span>{{row.reduce_amount}}</div>
                        <div><span class="_color">合计：</span>{{row.pay_amount}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="发货" min-width="120" max-width="180">
                    <template v-slot="{row}">
                        <div><span class="_color">方式：</span>{{row.deliver_type_text}}</div>
                        <div><span class="_color">物流：</span>{{row.express_name}}</div>
                        <div><span class="_color">运单：</span>{{row.express_no}}</div>
                        <div><span class="_color">进度：</span>{{row.state_text}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="回款" min-width="160" max-width="200">
                    <template v-slot="{row}">
                        <div><span class="_color">方式：</span>
                            {{row.pay_type_text}}
                            <span v-if="row.pay_type == 1">,预付{{row.pre_money}},应收{{(row.pay_amount - row.pre_money).toFixed(2)}}</span>
                        </div>
                        <div><span class="_color">回款：</span><span v-if="row.state == 70">{{(row.pay_amount - row.pre_money).toFixed(2)}}</span></div>
                        <div><span class="_color">跟单：</span>{{row.follow_state_text}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="业务" width="220">
                    <template v-slot="{row}">
                        <div><span class="_color">部门：</span>{{row.depart_name}}</div>
                        <div><span class="_color">入单：</span>{{row.admin.nick_name}} {{row.admin.phone}}</div>
                        <div><span class="_color">时间：</span>{{row.created_time}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" @size-change="changeOrderLimit"
                    @current-change="changeOrderPage" :current-page="ordersearch.page" :page-size="ordersearch.limit"
                    :total="ordersearch.total"></el-pagination>
        </el-dialog>
		
        <el-dialog title="回收号码" :visible="recycleVisiable" width="800px" center destroy-on-close @close="recycleVisiable=false">
			<div style="margin: 0 40px;">
                <div v-if="recycleType == 3">选中记录：<span class="red">{{selectedUsers.length}}</span></div>
                <div v-if="recycleType == 7">搜索记录：<span class="red">{{recycleNum}}</span></div>
                <div style="margin-top: 10px;">
                    收回后，员工的历史跟进记录将清空!!! 所选中客户资源的创建属性，将指派到以下指定部门或员工。
                </div>
                <div style="margin-top: 10px;display: flex;align-items: center;">
                    <div>指定部门或员工：</div>
                    <el-cascader v-model="recycle_depart_id" placeholder="请选择部门" :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" clearable style="width: 300px;"></el-cascader>
                    <el-select v-model="recycle_admin_id" clearable filterable placeholder="请选择员工" style="margin-left: 10px;" @visible-change="selectAdmin">
                        <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
                    </el-select>
                </div>
            </div>
            <span slot="footer">
                <el-button type="" @click="recycleVisiable = false">取 消</el-button>
                <el-button type="primary" :disabled="recycleNum <= 0 && selectedUsers.length <= 0" :loading="recycleLoading"  @click="handleRecycle">确 定</el-button>
            </span>
		</el-dialog>

        <Smssend :visible="smsVisible" :userArr="selectedUsers" @close="smsVisible = false" />

		<el-dialog title="申请线索" :visible="applyVisiable" width="800px" center destroy-on-close @close="applyVisiable=false">
            <el-form label-position="right" label-width="120px" :model="applyForm" class="pr_20">
                <div class="mb_20 ml_20">创建申请记录，提交至直属上级部门负责人审核</div>
                <el-form-item label="层次：">
                    <el-select v-model="applyForm.level_id" @change="handleApplyChange" @visible-change="getlevelTree">
                        <el-option v-for="(item,index) in levelTree" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型：">
                    <el-select v-model="applyForm.tag" @change="handleApplyChange">
                        <el-option v-for="(item,index) in tagArr" :key="index" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="额度：">
                    <span class="_color ml_20">{{applyForm.leftTimes}}</span> 次/今日
                    <span class="ml_40 _color">{{applyForm.limitPerTime}}</span> 条/次
                </el-form-item>
                <el-form-item label="申请条数：">
                    <el-input placeholder="" v-model="applyForm.quatity"/>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="" @click="applyVisiable = false">取 消</el-button>
                <el-button type="primary" @click="handleApply">确 定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog title="客户信息" :visible="represShow" width="1100px" center destroy-on-close @close="closeDetail">
		  <el-form label-position="right" :model="detail" label-width="100px" class="pr_20 detail_form">
			 <el-row :gutter="30">
				<el-col :span="6">
					<div class="bag_e br_8 p_10">
						<div class="t_r f_12 c9">ID：{{detail.id}}</div>
						<div>
                            <span class="f_20 c0">{{detail.name}}</span> 
                            <i class="el-icon-edit" style="margin-left: 10px;font-size: 16px;cursor: pointer;" @click="editName=true"></i>
                        </div>
						<div class="f_16 c0">{{detail.phone}}</div>
                        <div class="cup">
                            <div style="color: #F7BA1E;font-size: 1.6rem;font-weight: bold;">{{detail.level ? detail.level.name : ''}}</div>
                            <div style="background-color: #F7BA1E;color: #fff;border-radius: 20px;margin-top: 10px;padding: 10px 20px;">{{detail.level1 ? detail.level1.name : ''}}</div>
                        </div>
                        
						<div class="_flex_se t_c">
							<div>
								<div class="f_20 c0">{{detail.order_count}}</div>
								<div class="c7 f_12">订单次数</div>
							</div>
							<div>
								<div class="f_20 c0">{{detail.order_amount}}</div>
								<div class="c7 f_12">消费金额</div>
							</div>
						</div>
					</div>
					<div class="_button bag_blue mt_20 mb_20 p_10 _flex_c _f_ai" @click="openOrderLists(detail.id)">
						<i class="el-icon-tickets f_24 mr_5"></i>订单记录
					</div>
					<div style="display: grid;grid-template-columns: repeat(2, 1fr);gap: 10px;">
						<div class="_button bag" style="padding: 16px 15px 16px;" @click="handleSendSms">
							<i class="el-icon-tickets f_24"></i><br/>发送短信
						</div>
						<div class="_button bag_yellow" style="padding: 16px 15px 16px;" @click="handleOrderAdd(detail)">
							<i class="el-icon-tickets f_24"></i><br/>业务录单
						</div>
						<div class="_button bag_red mt_10" style="padding: 16px 15px 16px;" @click="openTodo"><i class="el-icon-tickets f_24"></i><br/>预约回访</div>
						<div class="_button bag_green mt_10" style="padding: 16px 15px 16px;" @click="openFollow"><i class="el-icon-tickets f_24"></i><br/>跟进记录</div>
					</div>
					<div class="c0 mt_10" v-for="(admin, index) in detail.admins" :key="index" style="display: flex;">
                        <span>所属：{{admin.nick_name}} {{admin.phone}}</span>
                        <el-popconfirm title="确定删除跟进人吗？" v-permit="'/admin/crm/userDelAdmin'" @confirm="delAdmin(detail.id, admin.admin_id)" style="margin-left: auto;color: red;cursor: pointer;">
                            <i class="el-icon-delete" slot="reference" title="删除跟进人"></i>
                        </el-popconfirm>
                    </div>
                    <div class="_button bag_green mt_20 mb_20 p_10 _flex_c _f_ai" v-permit="'/admin/crm/userAddAdmin'" @click="addAdminHandle(detail.id)">增加跟进人</div>

                    <div style="margin-top: 10px;" v-if="detail.is_hit == 1">
                        <el-popconfirm title="确定解除撞单限制吗？" @confirm="unfreezeHitHandler(detail.id)">
                            <el-button slot="reference" type="danger">解除撞单限制</el-button>
                        </el-popconfirm>
                    </div>

                    <div style="margin-top: 10px;" v-if="checkAuth('/admin/crm/userDel')">
                        <el-popconfirm title="确定要删除当前线索吗？" @confirm="del(detail.id)">
                            <el-button slot="reference">删除当前线索</el-button>
                        </el-popconfirm>
                    </div>
				</el-col>
				<el-col :span="10">
                    <el-form-item label="姓名：" v-if="editName">
                        <el-input placeholder="" v-model="detail.name" size="small" />
                    </el-form-item>
                    <el-form-item label="手机：" v-if="editName">
                        <el-input placeholder="" v-model="detail.phone" size="small" />
                    </el-form-item>
                    <el-form-item label="省市区：">
                        <el-cascader v-model="detail.region" :props="props" :key="cascaderKey" style="width: 300px;"></el-cascader>
                    </el-form-item>
                    <el-form-item label="地址：">
                        <el-input placeholder="" v-model="detail.address" placeholder="详细地址" size="small"/>
                    </el-form-item>
                    <div><span style="display: inline-block;width: 100px;text-align: right;box-sizing: border-box;padding-right: 12px;line-height: 40px;">导入金额：</span>{{detail.turnover}}</div>
                    <div><span style="display: inline-block;width: 100px;text-align: right;box-sizing: border-box;padding-right: 12px;line-height: 40px;">下单时间：</span>{{detail.import_order_time}}</div>
                    <div><span style="display: inline-block;width: 100px;text-align: right;box-sizing: border-box;padding-right: 12px;line-height: 40px;">导入产品：</span>{{detail.consumables}}</div>
                    <el-form-item label="性别：">
                        <el-radio-group v-model="detail.gender">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="2">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="生日：">
                        <el-date-picker v-model="detail.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="爱好：">
                        <el-input placeholder="" v-model="detail.hobby" size="small" />
                    </el-form-item>
                    <div style="display: flex;align-items: center;">
                        <label class="el-form-item__label" style="min-width: 100px;">需求：</label>
                        <div style="display: flex;flex-wrap: wrap;">
                            <el-checkbox v-model="detail.demand" v-for="(item,index) in detail.demandMap" :key="index" :label="item.code + ''">{{item.name}}</el-checkbox>
                        </div>
                    </div>
                    <div style="display: flex;align-items: center;">
                        <label class="el-form-item__label" style="min-width: 100px;">渠道：</label>
                        <div style="display: flex;flex-wrap: wrap;">
                            <el-checkbox v-model="detail.channel" v-for="(item,index) in detail.channelMap" :key="index" :label="item.code + ''">{{item.name}}</el-checkbox>
                        </div>
                    </div>
                    <div style="display: flex;align-items: center;">
                        <label class="el-form-item__label" style="min-width: 100px;">偏向：</label>
                        <div style="display: flex;flex-wrap: wrap;">
                            <el-checkbox v-model="detail.bias" v-for="(item,index) in detail.biasMap" :key="index" :label="item.code + ''">{{item.name}}</el-checkbox>
                        </div>
                    </div>
                    <el-form-item label="家庭：">
                        <el-input placeholder="" v-model="detail.family" size="small" />
                    </el-form-item>
                    <el-form-item label="消费：">
                        <el-input placeholder="" v-model="detail.consume" size="small" />
                    </el-form-item>
                    <el-form-item label="层次：">
                        <el-radio-group v-model="detail.gradation">
                            <el-radio :label="item.code" v-for="(item,index) in detail.gradationMap" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
				</el-col>
			   <el-col :span="8">
					<div class="f_18 c0">跟进历史</div>
					<!-- <div class="mt_10 _flex _f_fw c0">
						<div class="bag_d p_2 pr_10 pl_10 br_16 mr_10" v-for="item in typeArr" :key="item.code" >{{item.name}}</div>
					</div> -->
					<div class="_scroll mt_30" style="height: 100%;">
                        <el-scrollbar style="height: 60vh;">
						<el-steps direction="vertical" :active="1">
						    <el-step v-for="item in logArr" :key="item.id">
								<div slot="description" class=" f_14 mb_10">
									<p class="c0"><span class="_color">{{item.type_text}}：</span>{{item.created_time}}</p>
									<p class="c0" :title="item.content"><span class="_color">内容：</span>{{item.content.slice(0, 13)}}</p>
									<p class="c0"><span class="_color">操作：</span>{{item.admin.nick_name}} {{item.admin.phone.slice(-4)}}</p>
								</div>
							</el-step>
						  </el-steps>
                        </el-scrollbar>
					</div>
				</el-col>
			 </el-row>
		  </el-form>
            <span slot="footer">
                <el-button type="" @click="closeDetail">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
		</el-dialog>

        <el-dialog title="客户导出" :visible="exportVisible" @close="exportVisible=false" destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" top="50vh" width="35%">
            <div style="text-align: left;">
              <div>1、每次最多导出十万数据，请合理设置筛选条件，否则可能导致导出失败</div>
              <div style="margin-top: 10px;">2、导出文件为csv格式，可使用excel或wps打开，可另存为xlsx格式文件</div>
            </div>
            <span slot="footer">
                <el-button type="" @click="exportVisible = false">取消</el-button>
                <el-button type="primary" @click="userExport">导出</el-button>
            </span>
        </el-dialog>

        <el-dialog title="新增线索" :visible="addVisible" destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" top="20vh" center width="35%" @close="addVisible=false">
            <el-form :model="addForm" label-width="80px" ref="addForm" :rules="addFormRules">
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="addForm.name" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="电话：" prop="phone">
                    <el-input v-model="addForm.phone" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="地址：" prop="region">
                    <el-cascader v-model="addForm.region" :props="props" clearable style="width: 300px;margin-bottom: 10px;"></el-cascader>
                    <el-input v-model="addForm.address" placeholder="详细地址" clearable></el-input>
				</el-form-item>
                <el-form-item label="批次：" prop="batch_id">
                    <el-select v-model="addForm.batch_id" clearable filterable placeholder="请选择或搜索" @visible-change="getBatchLists">
                        <el-option v-for="item in batchArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="" @click="addVisible = false">取消</el-button>
                <el-button type="primary" v-loading="userAddLoading" @click="submitAdd('addForm')">保存</el-button>
            </span>
        </el-dialog>
        
        <el-dialog title="增加跟进人" :visible="addAdminVisible" width="800px" center destroy-on-close @close="addAdminVisible=false">
            <div class="mb_10 _flex _f_ai" @click="selectAdminVisible=true">
                选择员工：<span class="ml_20 red">{{selectedAdmins.length}}</span>
                <el-button type="success" size="small" plain style="margin-left: 20px;">选择员工</el-button>
            </div>
            <div style="width: 60%;display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px;margin-top: 10px;">
                <el-tag v-for="admin in selectedAdmins" :key="admin.admin_id" closable 
                    style="font-size: 16px;" @close="rmAdmin(admin.admin_id)"
                >{{admin.nick_name}} {{admin.phone.slice(-4)}}</el-tag>
            </div>
            <span slot="footer">
                <el-button type="" @click="addAdminVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAdminSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <div style="display: flex;">
            <!-- <el-checkbox-group v-model="allselect" size="small" @change="allSelectChange">
                <el-checkbox-button>跨页全选</el-checkbox-button>
            </el-checkbox-group> -->
            <el-button v-if="allselect" type="danger" size="small" @click="clearSelect" style="margin-left: 10px;">清空选择（{{allcount}}）</el-button>
            <el-button v-else type="danger" size="small" @click="clearSelect" style="margin-left: 10px;">清空选择（{{selectedUsers.length}}）</el-button>
            <el-dropdown @command="handleCommand" style="margin-left: 10px;">
                <el-button type="primary" size="small">批量操作 ></el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1" v-permit="'/admin/crm/dispatchDepart'">指派到部门</el-dropdown-item>
                    <el-dropdown-item command="2" v-permit="'/admin/crm/dispatchAdmin'">分配到员工</el-dropdown-item>
                    <el-dropdown-item command="3" v-permit="'/admin/crm/recycle'">回收号码</el-dropdown-item>
                    <el-dropdown-item command="7" v-permit="'/admin/crm/recycle'">一键回收</el-dropdown-item>
                    <el-dropdown-item command="4" v-permit="'/admin/crm/userDisable'">禁用/启用</el-dropdown-item>
                    <el-dropdown-item command="5" v-permit="'/admin/crm/userExport'">导出记录</el-dropdown-item>
                    <el-dropdown-item command="6" v-permit="'/admin/article/smsSend'">发送短信</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div style="margin-left: auto;">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 500, 1000, 5000]"
                @size-change="changeUserLimit" @current-change="changeUserPage"
                :current-page="userSearch.page" :page-size="userSearch.limit" :total="userSearch.total"></el-pagination>
        </div>
    </el-footer>
</el-container>
</template>
<script>
import AdminSelect from "@/components/select/AdminSelect.vue"
import CrmOrder from "@/components/crm/Order.vue"
import Smssend from "@/components/crm/Smssend.vue"
import base from "@/request/base.js"
import { userLists, userDetail, userEdit, userDisable, userLogs, dispatchDepart, dispatchAdmin, region, DepartmentLists, levelLists, followLog, todoAdd, crmorderLists, recycle, userExport, applyLeft, applyUser, crmorderDetail, userAdd, batchLists, adminLists, unfreezeHit, userAddAdmin, userDelAdmin,userDel } from "@/request/apis.js"
export default{
    components: { AdminSelect, CrmOrder, Smssend },
    data(){
        return {
            loginInfo: JSON.parse(localStorage.getItem('loginInfo')),
            departArr: [],
            tableLoading: false,
            allselect: false,
            allcount: 0,
            adminList: [],
            userSearchInit: {},
            userSearch: {
                page: 1,
                limit: 10,
                total: 0,
                batch_name: '',
                tag: '',
                name: '',
                phone: '',
                created_time: [],
                follow_time: [],
                depart: [],
                admin_phone: '',
                follow_count_min: '',
                follow_count_max: '',
                follow_time: [],
                order_count_min: '',
                order_count_max: '',
                level_id: '',
                level_id2: '',
            },
            list : [],
            tagArr: [],
            sourceArr: [],
            follow_state_arr: [],
            editName: false,
            detail: {},
            logArr: [],
            logSearch: {
                page: 1,
                limit: 10,
                total: 0,
                id: 0,
                type: 0,
            },

            selectedUsers: [],

            dispatchDepartVisible: false,
            dispatchDepartFormInit: {},
            dispatchDepartForm: {
                depart_id: '',
                tag: '',
                follow_state: '',
            },

            dispatchAdminVisible: false,
            dispatchAdminloading: false,
            dispatch_admin_follow_state: '',
            selectAdminVisible: false,
            selectedAdmins: [],

            recycleVisiable: false,
            recycle_depart_id: [],
            recycle_admin_id: '',
            recycleNum: '',
            recycleType: 3,
            recycleLoading: false,
            exportVisible: false,

            orderVisible: false,
            currentOrder: null,

            smsVisible: false,

            followVisible: false,
            followLoading: false,
            levelArr: [],
            levelFollowStateMap: [],
            followFormInit: {},
            followForm: {
                user_id: '',
                follow_state: '',
                content: '',
                level_id: '',
            },

            levelTree: [],
            applyVisiable: false,
            applyFormInit: {},
            applyForm: {
                tag: '',
                level_id: '',
                quatity: '',
                leftTimes: '-',
                limitPerTime: '-',
                undispatch: 0,
            },

            disableVisible: false,
            disableState: 1,

            todoVisible: false,
            todoFormInit: {},
            todoForm: {
                todo_time: '',
                todo_content: '',
            },

            cascaderKey: 0,
            props: {
                checkStrictly: true,
                lazy: true,
                lazyLoad: this.lazyLoadRegion,
            },

            orderListVisible: false,
            orderlist: [],
            ordersearch: {
                page: 1,
                limit: 10,
                total: 0,
                user_id: 0,
            },

			tabType : '1',
			alertType : 0,
			name:'',
			searchShow:false,
			show : false,
			represShow : false,
			formData : {
				name : ''
			},

            batchArr: [],
            addVisible: false,
            userAddLoading: false,
            addFormInit: {},
            addForm: {
                name: '',
                phone: '',
                region: [],
            },
            addFormRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { max: 30, message: '长度最多30个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { max: 11, message: '长度最多30个字符', trigger: 'blur' }
                ],
                region: [
                    { type: 'array', required: true, message: '请选择地址', trigger: 'change' }
                ],
                address: [
                    { max: 250, message: '长度最多250个字符', trigger: 'blur' }
                ],
                batch_id: [
                    { required: true, message: '请选择批次', trigger: 'blur' }
                ]
            },

            addAdminVisible: false,
            addAdminUserId: 0,
        }
    },
    mounted() {
        console.log('crmuser mounted', this.$route);
        this.applyFormInit = {...this.applyForm};
        this.followFormInit = {...this.followForm};
        this.todoFormInit = {...this.todoForm};
        this.dispatchDepartFormInit = {...this.dispatchDepartForm};
        this.addFormInit = JSON.parse(JSON.stringify(this.addForm));
        this.userSearchInit = structuredClone(this.userSearch);
        this.init();
    },
    // activated() {
    //     console.log('crmuser activated', this.$route);
    //     this.init();
    // },
    watch: {
        '$route'(to, from) {
            console.log('crmuser watch', to, from)
            if(to.path == '/crmuser'){
                this.init();
            }
        }
    },
	methods:{
        init(){
            this.userSearch = structuredClone(this.userSearchInit);
            this.userSearch.level_id = this.$route.query.level_id || '';
            this.userSearch.level_id2 = this.$route.query.level_id2 || '';
            this.getUserLists();
        },
        async getUserLists(page){
            if(page){
                this.userSearch.page = page;
            }
            this.tableLoading = true;
            var res = await userLists(this.userSearch);
            this.tableLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.list = res.data;
            this.userSearch.total = res.count;
            this.follow_state_arr = res.other.follow_state;
            this.tagArr = res.other.tag;
            this.sourceArr = res.other.source;
        },
        changeUserPage(page){
            this.getUserLists(page)
        },
        changeUserLimit(limit){
            this.userSearch.limit = limit;
            this.getUserLists(1)
        },
        async selectAdmin(query){
            if (!query || this.adminList.length) {
                return false;
            }
            let params = {limit: 1000};
            if(this.recycle_depart_id.length){
                params.depart_id = this.recycle_depart_id[this.recycle_depart_id.length - 1];
            }
            const res = await adminLists(params);
            if (res.code) {
                return this.$message.error(res.msg)
            }
            this.adminList = res.data;
        },
        async getDepartmentLists(query){
            if (!query || this.departArr.length) {
                return false;
            }
            var res = await DepartmentLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
        },
        async lazyLoadRegion(node, resolve) {
            const { level } = node;
            const parentId = node.value;
            console.log('lazyLoadRegion', node, parentId)

            const res = await region({ pid: parentId });
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            const nodes = res.data.map(item => ({
                value: item.region_id,
                label: item.region_name,
                leaf: level >= 3
            }));
            resolve(nodes);
        },
        async openDetail(id){
            var res = await userDetail({id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            res.data.region = res.data.region.filter(item => item)
            this.detail = res.data;
            this.getuserLogs();
            this.cascaderKey += 1;
            this.represShow = true;
        },
        closeDetail(){
            this.editName = false;
            this.represShow = false;
        },
        async unfreezeHitHandler(id){
            var res = await unfreezeHit({id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.detail.is_hit = 0;
        },
        async submit(){
            var res = await userEdit(this.detail);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.editName = false;
            this.represShow = false;
        },
        async getuserLogs(type = 0){
            var res = await userLogs({id: this.detail.id, type, limit: 20});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.logArr = res.data;
            this.$nextTick(()=>{
                var x = document.querySelectorAll(".el-step__icon-inner")
                if(x.length > 0){
                    x.forEach((item,index)=>{
                        item.innerHTML = x.length-index
                    })
                }
            })
        },
        handleSelectionChange(selection) {
            this.selectedUsers = selection;
            console.log('selectedUsers changed', this.selectedUsers);
        },
        clearSelect(){
            if(this.allSelect){
                this.allcount = 0;
            }else{
                this.$refs.multipleTable.clearSelection();
            }
        },
        allSelectChange(value){
            if(this.userSearch.total > 1000){
                return this.$message.error('客户数量不得大于1000，请合理设置筛选条件');
            }
            this.allSelect = value;
            this.allcount = this.userSearch.total;
            console.log('allSelectChange', this.allSelect, value)
        },
		async handleCommand(e){
            if(e != 7){
                if(this.selectedUsers.length == 0){
                    return this.$message.error('请选择客户');
                }
                if(this.selectedUsers.length > 1000){
                    return this.$message.error('客户数量不得大于1000');
                }
            }
            if(e == 1){
                this.getDepartmentLists(true);
                this.dispatchDepartForm = {...this.dispatchDepartFormInit};
                this.dispatchDepartVisible = true;
            }else if(e == 2){
                this.selectedAdmins = [];
                this.dispatch_admin_follow_state = '';
                this.dispatchAdminVisible = true;
            }else if(e == 3 || e == 7){
                this.getDepartmentLists(true);
                this.selectedAdmins = [];
                this.recycle_depart_id = [];
                this.recycle_admin_id = '';
                this.recycleVisiable = true;
                this.recycleType = e;
                
                if(e == 7){
                    this.recycleLoading = true;
                    var res = await userLists(this.userSearch);
                    this.recycleLoading = false;
                    if (res.code != 0) {
                        return this.$message.error(res.msg);
                    }
                    this.recycleNum = res.count;
                }
            }else if(e == 4){
                this.disableVisible = true;
            }else if(e == 5){
                this.exportType = 'table';
                this.exportVisible = true;
            }else if(e == 6){
                this.smsVisible = true;
            }else if(e<5 || e>=10){
				this.alertType = e
			}
		},
        async hanleDispatchDepart(){
            if(!this.dispatchDepartForm.depart_id){
                return this.$message.error('请选择部门');
            }
            let params = {
                ids: this.selectedUsers.map(v => v.id), 
                tag: this.dispatchDepartForm.tag,
                follow_state: this.dispatchDepartForm.follow_state,
                depart_id: this.dispatchDepartForm.depart_id[this.dispatchDepartForm.depart_id.length - 1],
            };
            let res = await dispatchDepart(params);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.dispatchDepartVisible = false;
            this.getUserLists();
        },
        rmAdmin(admin_id){
            this.selectedAdmins = this.selectedAdmins.filter(v => v.admin_id !== admin_id);
        },
        async handleDispatchAdmin(){
            if(this.selectedAdmins.length == 0){
                return this.$message.error('请选择员工');
            }
            this.dispatchAdminloading = true;
            var res = await dispatchAdmin({ids: this.selectedUsers.map(v => v.id), admin_ids: this.selectedAdmins.map(v => v.admin_id), follow_state: this.dispatch_admin_follow_state});
            this.dispatchAdminloading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.dispatchAdminVisible = false;
            this.getUserLists();
        },
		handleOrderAdd(detail){
            if(!this.detail.admin_id.includes(this.loginInfo.admin_id)){
                return this.$message.error('无权限录单');
            }
            if(this.detail.in_blacklist == 1){
                return this.$message.error('该客户已加入黑名单,请先解除黑名单');
            }
            if(this.detail.is_hit == 1){
                return this.$message.error('该客户已触发撞单限制,请先解除');
            }
            this.currentOrder = null;
            this.detail = {...detail};
            console.log('handleOrderAdd', this.currentOrder, this.detail)
            this.orderVisible = true;
        },
        async openFollow(user){
            user = user && user.id ? user : this.detail;
            this.followForm = {...this.followFormInit, user_id: user.id};
            console.log('openFollow', this.followForm, user)
            await this.getlevelLists();
            this.levelFollowStateMap = [];
            this.followForm.level_id = user.level_id;
            this.levelChange(user.level_id);
            this.followVisible = true;
        },
        async getlevelLists(){
            var res = await levelLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.levelArr = res.data;
        },
        async getlevelTree(query){
            if(!query || this.levelTree.length){
                return;
            }
            var res = await levelLists({tree: 1});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.levelTree = res.data;
        },
        levelChange(levelId){
            console.log('levelchange', this.levelArr, levelId)
            let level2 = this.levelArr.find(item => item.id === levelId);
            let level = this.levelArr.find(item => item.id === level2.pid);
            this.levelFollowStateMap = level.follow_state_map;
        },
        async handleFollow(){
            this.followLoading = true;
            var res = await followLog(this.followForm );
            this.followLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.followVisible = false;
            this.getUserLists();
        },
        async submitDisable(){
            var res = await userDisable({ids: this.selectedUsers.map(v => v.id), state: this.disableState});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.disableVisible = false;
            this.getUserLists();
        },
        openTodo(){
            this.todoForm = {...this.todoFormInit};
            this.todoVisible=true;
        },
        async todoHandle(){
            let res = await todoAdd({...this.todoForm, type: 1, follow_user_id: this.detail.id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '操作成功');
            this.todoVisible = false;
        },
        async getOrderLists(page) {
            if (page) {
                this.ordersearch.page = page;
            }
            var res = await crmorderLists(this.ordersearch);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.orderlist = res.data;
            this.ordersearch.total = res.count;
        },
        openOrderLists(id){
            this.ordersearch.user_id = id;
            this.getOrderLists();
            this.orderListVisible = true;
        },
        changeOrderPage(page){
            this.getOrderLists(page);
        },
        changeOrderLimit(limit){
            this.ordersearch.limit = res.limit;
            this.getOrderLists(1);
        },
        async handleRecycle(){
            var base = {clear_follow: 1, recycle_depart_id: this.recycle_depart_id, recycle_admin_id: this.recycle_admin_id, recycle_type: this.recycleType};
            var params = this.recycleType == 7 ? {...this.userSearch, ...base} : {ids: this.selectedUsers.map(v => v.id).join(','), ...base};
            this.recycleLoading = true;
            var res = await recycle(params);
            this.recycleLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.recycleVisiable = false;
            this.getUserLists();
        },
        userExport(){
            let loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
            let auth = "&sid=" + loginInfo.sid + '&token=' + loginInfo.token + '&uid=' + loginInfo.admin_id;
            let query;
            if(this.exportType == 'table'){
                query = 'id=' + this.selectedUsers.map(v => v.id).join(',');
            }else{
                query = Object.keys(this.userSearch).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.userSearch[key])}`).join('&');
            }
            var url = base.domain + '/admin/crm/userExport?' + query + auth;
            console.log(url);
            window.open(url);
            this.exportVisible = false;
        },
        handleSendSms() {
            this.selectedUsers = [this.detail];
            this.smsVisible = true;
        },
        async openApply(){
            this.applyForm = {...this.applyFormInit};
            this.applyVisiable = true;
        },
        async handleApplyChange(){
            if(!this.applyForm.level_id || !this.applyForm.tag){
                return;
            }
            let res = await applyLeft({level_id1: this.applyForm.level_id, tag: this.applyForm.tag});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.applyForm = {...this.applyForm, ...res.data}
        },
        async handleApply(){
            if(!this.applyForm.quatity || !this.applyForm.level_id || !this.applyForm.tag){
                return this.$message.error('请填写完整');
            }
            let res = await applyUser({quatity: this.applyForm.quatity, level_id1: this.applyForm.level_id, tag: this.applyForm.tag});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.applyVisiable = false;
        },
        async openDraft(detail, id){
            let res = await crmorderDetail({id});
            if(res.code !== 0){
                return this.$message.error(res.msg);
            }
            this.currentOrder = res.data;
            this.detail = {...detail};
            console.log('openDraft', this.currentOrder, this.detail)
            this.orderVisible = true;
        },

        openAdd(){
            this.addForm = JSON.parse(JSON.stringify(this.addFormInit));
            this.addVisible = true;
        },
        async getBatchLists(query){
            if(query){
                var res = await batchLists({limit: 1000, is_manul: 1, noLimitDepart: 1});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.batchArr = res.data;
            }
        },
        submitAdd(formName) {
            if(this.userAddLoading){
                return this.$message.error('提交中,请勿重复提交');
            }

            this.$refs[formName].validate(async (valid) => {
                if (!valid) {
                    return false;
                }
                
                this.userAddLoading = true;
                let res = await userAdd(this.addForm);
                if(res.code !== 0){
                    this.userAddLoading = false;
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.userAddLoading = false;
                this.addVisible = false;
                this.getUserLists();
            });
        },


        addAdminHandle(id){
            this.selectedAdmins = [];
            this.addAdminUserId = id;
            this.addAdminVisible = true;
        },
        async addAdminSubmit(){
            let res = await userAddAdmin({user_id: this.addAdminUserId, admin_id: this.selectedAdmins.map(v => v.admin_id)});
            if(res.code !== 0){
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.addAdminVisible = false;
            this.openDetail(this.addAdminUserId)
        },
        async delAdmin(user_id, admin_id){
            let res = await userDelAdmin({user_id, admin_id});
            if(res.code !== 0){
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.openDetail(user_id)
        },
        async del(id){
            let res = await userDel({id});
            if(res.code !== 0){
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.represShow = false;
            this.getUserLists();
        }
	}
}
</script>

<style  scoped>
p{margin: 0;}
.detail_form ::v-deep .el-form-item{
	height: 36px;
}
/deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }


.search-container {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: start;
    gap: 10px;
    padding-bottom: 10px;
}
.left-part {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    transition: max-height 0.3s ease;
}
.left-part.collapsed {
    overflow: hidden;
    max-height: 38px;
}
.right-part {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    align-items: center;
}
.left-part .el-input {
    width: 150px;
}
.right-part a._color {
    width: 80px;
    text-align: center;
}
.cup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100px;
    background-image: url('bg.svg');
    background-position: center;
    background-repeat: no-repeat;
}
</style> 